import React from "react";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { FormHelperText } from "@material-ui/core";

export interface SelectorDisplayItemProps {
	//This string to be displayed in the menu.
	displayString: string;
	//The string to be passed back with item is stelected.
	valueString?: string;
}

interface SelectorProps {
	//The items to display in the dropdown.
	items: SelectorDisplayItemProps[];
	//call back method to be used when item is selected
	updateSelected: (string) => void;
	//The value of the menu item to be displayed when the list is closed.
	initialValue: string;
	//The label for the selector.
	label: string;
	//Message to be displayed on invalid selection.
	errorMessage?: string;
	//A message to be displayed to help user understand UI feedback.
	helperMessage?: string;
}

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		root: {
			display: "flex",
			flexWrap: "wrap",
		},
		formControl: {
			margin: theme.spacing(1),
			minWidth: 120,
		},
		selectEmpty: {
			marginTop: theme.spacing(2),
		},
	}),
);

/**
 * This is a wrapper for a material ui dropdown selector. You can add menu items that have display and value strings
 * that will feed back the selected item to the parent through the callback method.
 * @param props
 */
export const Selector = (props: SelectorProps) => {
	const classes = useStyles();

	const handleChange = (event: React.ChangeEvent<{ name?: string; value: unknown }>) => {
		props.updateSelected(String(event.target.value));
	};

	let error = false;
	if (props.errorMessage && props.errorMessage !== "") {
		error = true;
	}

	function displayHelperText() {
		if (error) {
			return (
				<FormHelperText data-testid="selector-error-text" error={error}>
					{props.errorMessage}
				</FormHelperText>
			);
		} else {
			return <FormHelperText data-testid="selector-helper-text">{props.helperMessage}</FormHelperText>;
		}
	}

	return (
		<form className={classes.root}>
			<FormControl className={classes.formControl}>
				<InputLabel shrink data-testid="selector-label" htmlFor={props.label}>
					{props.label}:
				</InputLabel>
				<Select
					style={{ marginTop: "24px" }}
					error={error}
					onChange={handleChange}
					value={props.initialValue}
					inputProps={{
						name: props.label,
						id: props.label,
					}}
				>
					{props.items.map((item) => (
						<MenuItem key={item.valueString} value={item.valueString} title={item.valueString}>
							{item.displayString}
						</MenuItem>
					))}
				</Select>
				{displayHelperText()}
			</FormControl>
		</form>
	);
};
